/* ==================================================
  ヘッダー検索 キーワード未入力時の遷移
  Boost AI Search がヘッダー検索フォームのクリックを
  preventDefault するため、ネイティブの form 送信が発火しない。
  未入力時のみ自前で検索ページへ遷移させる。
  キーワードありの場合は Boost の挙動に任せる。
===================================================*/

(function () {
  'use strict';

  const LOG_PREFIX = '[c_header-search-empty]';
  const SEL_FORM = '.predictive-search__form';
  const SEL_SUBMIT = '.c_search-submit';
  const SEL_INPUT = 'input[name="q"]';

  /*  遷移は一度だけ。capture と要素側の両方で拾うため二重発火を防ぐ  */
  let hasNavigated = false;

  /* ------------------------------
    判定
  ------------------------------*/

  function isEmptyKeyword(form) {
    const input = form.querySelector(SEL_INPUT);
    return !input || input.value.trim() === '';
  }

  /*  フォームの action と hidden の type から遷移先を組み立てる  */
  function buildSearchUrl(form) {
    const action = form.getAttribute('action') || '/search';
    const typeInput = form.querySelector('input[name="type"]');

    if (typeInput && typeInput.value) {
      return action + '?type=' + encodeURIComponent(typeInput.value);
    }

    return action;
  }

  function goToSearch(form) {
    if (hasNavigated) return;

    hasNavigated = true;

    try {
      window.location.href = buildSearchUrl(form);
    } catch (e) {
      hasNavigated = false;
      console.warn(LOG_PREFIX + ' 検索ページへの遷移に失敗しました', e);
    }
  }

  /* ------------------------------
    イベント
  ------------------------------*/

  /*
    Boost がクリックを preventDefault しても location 代入は取り消されないため、
    ハンドラの実行順に依存せず遷移できる。
  */
  function onSubmitButtonClick(event) {
    const button = event.target.closest(SEL_SUBMIT);
    if (!button) return;

    const form = button.closest(SEL_FORM);
    if (!form || !isEmptyKeyword(form)) return;

    event.preventDefault();
    goToSearch(form);
  }

  /*  Enter も同様にネイティブ送信が起きないため自前で処理する  */
  function onInputKeydown(event) {
    if (event.key !== 'Enter' || event.isComposing) return;

    const input = event.target.closest(SEL_FORM + ' ' + SEL_INPUT);
    if (!input) return;

    const form = input.closest(SEL_FORM);
    if (!form || !isEmptyKeyword(form)) return;

    event.preventDefault();
    goToSearch(form);
  }

  /* ------------------------------
    初期化
  ------------------------------*/

  /*
    document の capture と各ボタン自身の両方に登録する。
    Boost が document の capture で stopPropagation する場合に備えた二重化。
  */
  document.addEventListener('click', onSubmitButtonClick, true);
  document.addEventListener('keydown', onInputKeydown, true);

  function bindDirectListeners() {
    document.querySelectorAll(SEL_FORM + ' ' + SEL_SUBMIT).forEach((button) => {
      button.addEventListener('click', onSubmitButtonClick);
    });

    document.querySelectorAll(SEL_FORM + ' ' + SEL_INPUT).forEach((input) => {
      input.addEventListener('keydown', onInputKeydown);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindDirectListeners);
  } else {
    bindDirectListeners();
  }
})();
